// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c2e241b","455":"262e180d"}[chunkId] + ".chunk.js";
};